function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "142"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M96 16v-2H80V8a8 8 0 00-8-8H24a8 8 0 00-8 8v6H0v2a30 30 0 0016 26.53V54H0v2a30 30 0 0016 26.53V94H0v2a30 30 0 0016 26.53V134a8 8 0 008 8h48a8 8 0 008-8v-11.47A30 30 0 0096 96v-2H80V82.53A30 30 0 0096 56v-2H80V42.53A30 30 0 0096 16zm-24 94.2a23.68 23.68 0 01-6 15.8 23.7 23.7 0 01-17.79 8h-.4A23.7 23.7 0 0130 126a23.68 23.68 0 01-6-15.8V29.8A23.82 23.82 0 0147.8 6h.4A23.82 23.82 0 0172 29.8z",
  fill: "#c0c7cb"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "48",
  cy: "30",
  r: "16",
  fill: "#c0c7cb"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "48",
  cy: "70",
  r: "16",
  fill: "#9ea8ae"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "48",
  cy: "110",
  r: "16",
  fill: "#c0c7cb"
}));